export const RELATED_PUBLICATIONS_CONSTS = {
  deletePublicationFromStory: 'Удалить публикацию из сюжета',
  viewOnSiteMsg: 'Посмотреть на сайте',
  withoutName: 'Без названия'
}
